export default function rejectError(error) {
  const errorObj = {
    data: {
      errors: [
        error,
      ],
    },
  };

  return Promise.reject(errorObj);
}
